import { ShieldCheck, RefreshCw, Clock, BadgeCheck } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "Replacement guarantee" },
  { icon: RefreshCw, label: "Month-to-month" },
  { icon: Clock, label: "US-hour coverage" },
  { icon: BadgeCheck, label: "Trained on US REI" },
];

const ServiceTrustStrip = () => (
  <section className="border-b border-border bg-card">
    <div className="container-narrow px-4 py-6 md:px-8 lg:px-16">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {items.map((it) => (
          <div
            key={it.label}
            className="flex items-center gap-2.5 rounded-lg border border-border bg-background px-3 py-2.5"
          >
            <it.icon className="h-4 w-4 shrink-0 text-secondary" />
            <span className="text-xs font-semibold text-foreground">{it.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServiceTrustStrip;
